/** Small, dependency-free id generator with a monotonic component. */
let counter = 0

export function createId(prefix = 'id'): string {
  counter += 1
  const random = Math.random().toString(36).slice(2, 8)
  return `${prefix}_${counter.toString(36)}${random}`
}

/** Test helper: makes id sequences predictable. */
export function resetIdCounter(value = 0): void {
  counter = value
}
